import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MUILinearProgress(theme: Theme): Components['MuiLinearProgress'] {
  return {
    defaultProps: {
      color: 'neutral',
    },
    styleOverrides: {
      root: {
        width: '100%',
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden',
      },
      bar: {
        borderRadius: theme.shape.borderRadius,
      },
    },
  };
}
